export default [
  {
    text: 'constrain.table.name',
    value: 'name',
  },
  {
    text: 'constrain.table.active',
    value: 'isActive',
    type: 'slot',
    default: false,
    editable: true,
  },
];
